var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

/**
 * @constructor
 */
var FlipStateMachine = function (root, model, selectionModel) {
    var self = this;
    this.root = root;

    this.model = model;
    this.selectionModel = selectionModel;

    lib_core.StateMachine.call(this);

    // horizontal
    this.addTransition("idle", "idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.FLIP_HOR_BUTTON
                    || cEvent.isKeyPressed('S_f') );
        },
        function(cEvent){
            var alreadyRecording = self.root.isRecording(); // TODO: not a good solution! this rotateSM shouldn't be merged in each and every state, placingSM should include this without the rec - stoprec itself!
            if (!alreadyRecording) self.root.rec();
            self.flipSelection('HOR');
            if (!alreadyRecording) self.root.stopRec();
        }
    );

    // vertical
    this.addTransition("idle", "idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.FLIP_VER_BUTTON
                    || cEvent.isKeyPressed('f') );
        },
        function(cEvent){
            var alreadyRecording = self.root.isRecording(); // TODO: not a good solution! this rotateSM shouldn't be merged in each and every state, placingSM should include this without the rec - stoprec itself!
            if (!alreadyRecording) self.root.rec();
            self.flipSelection('VER');
            if (!alreadyRecording) self.root.stopRec();
        }
    );
};
lib_core.inherit(FlipStateMachine, lib_core.StateMachine);

module.exports = FlipStateMachine;

FlipStateMachine.prototype.flipSelection = function(type) {
    var self = this;

    if(this.selectionModel.selection.size() > 0) {
        var center = null;
        if(this.selectionModel.selection.size() > 1)
            center = this.selectionModel.selectedBoundingBox().getCenter();
        else
            if(this.selectionModel.selection.getOne().getPos) {
                center = this.selectionModel.selection.getOne().getPos();
            }

        this.selectionModel.selection.forEach(function(selectable){
            if (selectable && selectable.flip) {
                if (type === 'VER')
                    selectable.flip(new lib_geometry.Line(lib_geometry.Line.VER, center));
                else if (type === 'HOR')
                    selectable.flip(new lib_geometry.Line(lib_geometry.Line.HOR, center));
            }
        });
    }
};
